import { ApiProperty } from "@nestjs/swagger";
import { VehicleTypeEnum } from "@project-management-system/shared-models";

export class VehicleTypeReq {

    @ApiProperty()
    vehicleType: string;
    @ApiProperty()
    categoryId?: string;
}

